var _path, _rect, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCatalystRan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,65.87256a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75v-16a.7502.7502,0,0,0-.75-.75H40.75v-19.25h-1.5v19.25H10a.7502.7502,0,0,0-.75.75Zm1.5-15.25h58.5v14.5H10.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 57.12256,
    width: 30,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 57.97876,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 57.97876,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 57.97876,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23.97876,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8623,12.0874l-1.02539-1.09472A17.86174,17.86174,0,0,0,22.207,23.97852a17.66153,17.66153,0,0,0,5.334,12.70263l1.05078-1.07129a16.291,16.291,0,0,1,.2705-23.52246Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.793,23.97852a17.64265,17.64265,0,0,0-5.46973-12.834l-1.03906,1.082a16.29169,16.29169,0,0,1,.23633,23.273l1.06054,1.06055A17.67656,17.67656,0,0,0,57.793,23.97852Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.668,20.31152a5.67605,5.67605,0,0,0-.23731,7.03418q.15528.21094.33008.40625l1.1211-.99609c-.085-.09619-.166-.19531-.24317-.29981a4.1766,4.1766,0,0,1,.17383-5.17578Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.126,26.74707l1.123.99512q.16407-.18531.31055-.38281a5.67714,5.67714,0,0,0,.08887-6.6377,5.33533,5.33533,0,0,0-.332-.42773l-1.13868.97558c.085.09961.165.20313.24219.3125a4.177,4.177,0,0,1-.06543,4.88379Q43.2461,26.61158,43.126,26.74707Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.335,31.64551l1.11914-.99805q-.30907-.34716-.58594-.72217a10.1057,10.1057,0,0,1,.42188-12.52l-1.14453-.96972a11.606,11.606,0,0,0-.48438,14.38037Q30.979,31.24659,31.335,31.64551Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.56152,30.62988l1.123.99317c.22266-.25147.43555-.51221.63574-.78223A11.60805,11.60805,0,0,0,49.5,17.27148c-.21094-.30029-.43652-.58984-.67285-.86816l-1.14258.97168q.31054.36474.58789.7583a10.10786,10.10786,0,0,1-.15723,11.814C47.94043,30.18311,47.75488,30.41064,47.56152,30.62988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCatalystRan);
export default __webpack_public_path__ + "static/media/icon_catalyst_ran.8c2919aff9c84a4063d70346560662d3.svg";
export { ForwardRef as ReactComponent };